import { render, staticRenderFns } from "./ContextMenu1.vue?vue&type=template&id=24918d48"
import script from "./ContextMenu1.vue?vue&type=script&lang=js"
export * from "./ContextMenu1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports